import { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { OrderList } from 'mobily-ui-library/lib'

import OrderListImg1 from '../../assets/OrderListImg1.jpg'
import { GlobalContext } from '../../context/GlobalContext'
import { useWindowSize } from '../Util/WindowResize'
import './ListOfOrders.scss'

const OrdersData = (props: any) => {
  const { t } = useTranslation()
  const [state, dispatch]: any = useContext(GlobalContext)
  const { rtl, inquiryRes } = state
  const { isOrderActive } = props

  const [width] = useWindowSize()
  let ordersData = []
  const [orders, setOrders] =
    // prettier-ignore
    useState<{
    key: number,
    orderNumber: string,
    phoneNumber: string,
    isOrderActive: string,
    image: string,
    orderPlacedDate: string,
    totalAmount: string,
  }[]>([])

  useEffect(() => {
    const ordersFilter = (order: any) => {
      const { orderInfo } = order
      return orderInfo.IsOrderActive === isOrderActive
    }

    ordersData = inquiryRes.orders.filter(ordersFilter)
    ordersData?.forEach(function (order: any, index: any) {
      const { orderInfo, orderSummary } = order
      setOrders(orders => [
        ...orders,
        {
          key: index,
          orderNumber: orderInfo.OrderNumber,
          phoneNumber: orderInfo?.MSISDN === "" || orderInfo?.MSISDN === "NA" ? "" : orderInfo.MSISDN,
          isOrderActive: orderInfo.IsOrderActive,
          image: orderInfo?.PlanImage === "" || orderInfo?.PlanImage === "NA" ? OrderListImg1 : orderInfo.PlanImage,
          orderPlacedDate: orderInfo?.OrderPlacedDate === "" || orderInfo?.OrderPlacedDate === "NA" ? "" : orderInfo.OrderPlacedDate,
          totalAmount: orderSummary?.TotalAmount,
        },
      ])
    })
  }, [isOrderActive])

  const handleOrderClick = (oId: any) => {
    const inquiryResData = inquiryRes.orders.filter((value: any) => {
      return value.orderInfo.OrderNumber === oId
    })
    dispatch({ type: 'LIST_OF_ORDERS_SUCCESS', payload: { selectedOrderDetails: inquiryResData } })
    dispatch({ type: 'GO_TO_SCREEN', payload: { page: 'OrderDetails' } })
  }

  return (
    <>
      {orders.map((order, index) => {
        return (
          <ul className="listOfOrders_list">
            <li onClick={() => handleOrderClick(order.orderNumber)} key={index}>
              <OrderList
                rtl={rtl}
                screenWidth={width}
                numberOfOrders={1} //Need to get this orderData
                orderListFirstImage={order.image}
                trackingNumberTitle={t('tracking_number_title')}
                trackingNumber={order.orderNumber}
                orderPlacedDateTitle={t('order_placed_title')}
                orderPlacedDate={order.orderPlacedDate.split('/', 1)}
                totalPriceTitle={t('total_price_title')}
                totalPrice={order.totalAmount}
              />
            </li>
          </ul>
        )
      })}
    </>
  )
}

export default OrdersData
